import { useEffect, useRef } from 'react'

let instances = 0

const BackgroundLogo = ({
  primaryColor,
  secondaryColor
}) => {
  const instance = useRef(instances)
  
  useEffect(() => {
    instances++
  }, [])

  return (
    <svg
      viewBox="0 0 1376 1563"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={`
        position: absolute;
        top: 50%;
        left: 50%;
        width: 125%;
        height: 125%;
        transform: translate(-50%, -50%);
        pointer-events: none;
      `}
    >
      <g
        opacity=".05"
        filter={`url(#filter-BackgroundLogo${instance.current})`}
      >
        <path
          d="M1232.14 1129.01l112.69-880.223c8.05-63.628-57.83-110.556-115.65-82.653L966.109 294.235l22.029-173.338C994.28 70.164 953.824 30 907.649 30c-11.65 0-23.723 2.537-35.373 8.244L188.759 370.546c-24.782 12.049-41.515 35.513-45.116 62.359L31.171 1314.6c-8.049 63.63 57.825 110.56 115.438 82.66l263.282-127.89-22.028 171.86c-8.049 63.62 57.824 110.55 115.649 82.44l683.728-332.3c24.57-11.84 41.52-35.31 44.9-62.36zm-125.39-146.919c-6.99 57.079-42.78 106.539-94.47 131.699l-322.585 156.42c-11.226 5.5-22.664 7.82-33.89 7.82-44.057 0-83.031-38.47-76.888-86.88l392.487-190.03 20.122-158.967-78.582-55.807c-7.413-5.073-6.354-16.277 1.695-20.293l233.841-113.727-41.73 329.765zm62.7-496.761L776.961 675.79l-29.018 227.877c-4.448 34.879-26.265 65.318-58.037 80.75L292.971 1176.99c-7.625 3.59-15.251 5.29-22.876 5.29-29.442 0-55.495-25.79-51.47-58.35l64.179-510.288-81.124-57.497c-7.414-5.074-6.355-16.277 1.694-20.294l518.092-251.128c47.87-23.253 102.517 15.854 95.739 68.701l-2.33 18.602L422.6 562.275l-56.342 446.875 250.573-121.549 20.122-158.964-81.124-58.554c-7.201-5.074-6.142-16.277 1.907-20.293l501.354-243.097c55.08-27.057 117.98 17.757 110.36 78.637z"
          stroke={`url(#gradient-BackgroundLogo${instance.current})`}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id={`gradient-BackgroundLogo${instance.current}`}
          x1="688"
          y1="30"
          x2="688"
          y2="1532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primaryColor} />
          <stop offset="1" stopColor={secondaryColor} />
        </linearGradient>
        <filter
          id={`filter-BackgroundLogo${instance.current}`}
          x=".5"
          y="0"
          width="1375"
          height="1562"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            radius="4"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow"
          />
          <feOffset/>
          <feGaussianBlur stdDeviation="12.5"/>
          <feColorMatrix
            values="0 0 0 0 0.286275 0 0 0 0 0.901961 0 0 0 0 0.607843 0 0 0 0.25 0"
          />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default BackgroundLogo